import React, { ChangeEvent } from "react";
import { Search } from "@platzi/icons";
import styles from "./InputSearch.module.sass";

interface InputSearchProps {
  value: string;
  onChange: (value: string) => void;
  customStyles?: string;
}

export const InputSearch = ({ value, onChange, customStyles }: InputSearchProps) => {
  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className={`${styles.InputSearch} ${customStyles}`}>
      <Search />
      <input
        placeholder="Busca por nombre o e-mail"
        value={value}
        onChange={handleInputChange}
        data-qa="input-search"
      />
    </div>
  );
};
